/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { MimeTypes } from '../types/utils';

export type FileID = string;

export class File {
	id: FileID = ''

	isFeatured?: boolean

	mimeType?: MimeTypes

	name?: string

	title?: string

	url?: string
}